<template>
  <v-container>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="primary"
          fixed
          bottom
          left
          v-on="on"
          @click="$router.push(`/`)"
        >
          <v-icon>mdi-puzzle</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("navigationBar.module") }}</span>
    </v-tooltip>
    <v-card class="mt-12">
      <v-card-title class="primary white--text font-weight-bold">
        <span id="v-step-equipment-list-0">{{
          this.$t("equipmentList.plantList")
        }}</span>
        <!-- <export-2-excel
          :dark="true"
          filename="meru-equipment-list"
          sheetname="equipment-list"
          :datos="exportDatos"
        ></export-2-excel> -->
        <v-spacer></v-spacer>
        <v-text-field
          id="v-step-equipment-list-1"
          dark
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('equipmentList.label-search')"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-card-text class="pa-10" v-if="equipmentsList.length > 0">
        <!-- Elemento de Plant -->
        <div v-for="plant in plantsAndAreasWithStatus" :key="plant.name">
          <h3>{{ plant.name }}</h3>
          <v-list v-for="area in plant.areas" :key="area.name">
            <v-list-group :value="true" prepend-icon="mdi-texture-box">
              <template v-slot:activator>
                <v-list-item-title>Area: {{ area.name }}</v-list-item-title>
                <v-list-item-action>
                  <plant-details
                    type="area"
                    :info="area"
                    :equipmentsPerUnit="equipmentsPerUnit"
                  ></plant-details>
                </v-list-item-action>
              </template>

              <!-- Elemento del Area -->

              <v-list-group
                v-for="unit in area.units"
                :key="unit.name"
                :value="true"
                no-action
                sub-group
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title
                      ><v-icon
                        :color="
                          unit && unit.status && unit.status.color
                            ? unit.status.color
                            : '#008450'
                        "
                        >mdi-circle</v-icon
                      >{{ unit.name }}</v-list-item-title
                    >
                  </v-list-item-content>
                </template>

                <!-- Elemento de Unit -->
                <template v-if="equipmentsPerUnit[unit.name]">
                  <v-list-item
                    v-for="equipment in equipmentsPerUnit[unit.name].equipments"
                    :key="equipment.equipTag"
                    @click="rowClick(equipment.id)"
                  >
                    <v-icon
                      :color="
                        equipment.lastInspection &&
                        equipment.lastInspection.status &&
                        equipment.lastInspection.status.color
                          ? equipment.lastInspection.status.color
                          : '#008450'
                      "
                      >mdi-circle</v-icon
                    >
                    <v-list-item-title
                      v-text="equipment.equipTag"
                    ></v-list-item-title>
                    <v-list-item-subtitle
                      v-html="filterEquipmentType(equipment.equipmentType)"
                    ></v-list-item-subtitle>

                    <!-- <v-list-item-icon>
                    <v-icon v-text="icon"></v-icon>
                  </v-list-item-icon> -->
                  </v-list-item>
                </template>
                <!-- Fin del elemento de unit -->
              </v-list-group>
            </v-list-group>
          </v-list>
          <v-divider class="my-5"></v-divider>
          <!-- Fin del elemento de Area -->
        </div>
        <!-- Fin del elemento de Plant -->
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import lodash from "lodash";

export default {
  components: {
    PlantDetails: () => import("./PlantDetails")
  },
  mounted: function() {
    if (!this.user?.equipmentListTour) {
      this.$tours["equipmentListTour"].start();
    }
  },
  data() {
    return {
      search: ""
    };
  },
  computed: {
    ...mapGetters("equipments", ["equipmentsList"]),
    ...mapState("settings", ["equipmentType"]),
    ...mapState("auth", ["user"]),
    filteredEquipments() {
      return this.equipmentsList.filter(eq => {
        if (this.search.toLowerCase().includes("area ")) {
          const areaSearch = this.search.toLowerCase().replace("area ", "");
          return eq.area.name.toLowerCase().includes(areaSearch);
        }
        return (
          eq.equipTag.toLowerCase().includes(this.search.toLowerCase()) ||
          eq.plant.name.toLowerCase().includes(this.search.toLowerCase()) ||
          eq.unit.name.toLowerCase().includes(this.search.toLowerCase()) ||
          eq.area.name.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
    plantsList() {
      let plantsList = [];
      let plantsNames = [];
      this.filteredEquipments.forEach(equipment => {
        if (!plantsNames.includes(equipment.plant.name)) {
          plantsList.push(equipment.plant);
          plantsNames.push(equipment.plant.name);
        }
      });

      return plantsList;
    },
    equipmentsPerUnit() {
      if (this.equipmentsList.length > 0) {
        let final = {};
        const grouped = lodash.groupBy(this.filteredEquipments, "unit.name");

        Object.entries(grouped).forEach(([unitName, equipments]) => {
          let status = { color: "#676767", name: "No Data ", value: 0 };
          equipments.forEach(equipment => {
            if (equipment.lastInspection?.status.value >= status.value) {
              status = equipment.lastInspection.status;
            }
          });

          final[unitName] = {
            status,
            equipments
          };
        });
        return final;
      }
      return {};
    },
    plantsAndAreasWithStatus() {
      const plantsWithStatus = this.plantsList.map(plant => {
        let plantStatus = { value: 0 };
        let areas = plant.areas.map(area => {
          let areaStatus = { value: 0 };
          let units = area.units.map(unit => {
            if (
              this.equipmentsPerUnit[unit.name]?.status?.value >=
              areaStatus.value
            ) {
              areaStatus = this.equipmentsPerUnit[unit.name].status;
            }
            if (
              this.equipmentsPerUnit[unit.name]?.status?.value >=
              plantStatus.value
            ) {
              plantStatus = this.equipmentsPerUnit[unit.name].status;
            }
            return {
              ...unit,
              status: this.equipmentsPerUnit[unit.name]?.status
                ? this.equipmentsPerUnit[unit.name]?.status
                : { color: "#676767", name: "No Data ", value: 0 }
            };
          });

          const filteredUnits = units.filter(unit =>
            Object.keys(this.equipmentsPerUnit).includes(unit.name)
          );
          return {
            ...area,
            units: filteredUnits,
            status: areaStatus
          };
        });
        const filteredAreas = areas.filter(area => area.units.length > 0);
        return {
          ...plant,
          areas: filteredAreas,
          status: plantStatus
        };
      });

      return plantsWithStatus || [];
    }
  },

  methods: {
    rowClick(id) {
      this.$router.push({
        name: "EquipmentProfile/Dashboard",
        params: { id }
      });
    },
    filterEquipmentType(item) {
      let res = this.equipmentType.filter(e => e.id == item)[0];
      let name = res.name;
      let mainClass = res.mainClass;
      let subtype = res.subtype ? `- ${res.subtype}` : "";
      return `[${mainClass}] ${name} ${subtype}`;
    }
  },
  filters: {
    FixingDate: function(value) {
      return moment.unix(value.seconds).format("MMMM D YYYY, h:mm:ss a");
    }
  }
};
</script>
